import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { RootState } from '../../../stores/store'; 
import { useAppSelector, useAppDispatch } from '../../../stores/hooks'
import EnvironementSettings from './environmentsettings';

export default function   EnvironmentSettingDialog   ( )  {
  
  const isEnvSettingDialogOpen = useAppSelector((state:RootState) => state.envSettingDialogReducer.isEnvSettingDialogOpen);
  
  
  return (
    
     
    <Dialog open={isEnvSettingDialogOpen} maxWidth={false}>
      <DialogTitle>Environment Settings</DialogTitle>
      
      <DialogContent dividers >
      
      <EnvironementSettings />
       
      </DialogContent>
    </Dialog>
  
  );
 
};

//export default ChangePasswordPopup;
